// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"b647fe3c","239":"51df6d43","667":"7338802f","977":"f710a6a3"}[chunkId] + ".chunk.js";
};